import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FreeTrialInfoBanner.module.scss';
import { ReactComponent as InfoIcon } from '../../assets/images/icons/icon_info_filled.svg';
import { FreeTrialRestrictionReason } from '../../hooks/useFreeTrialEligibility';

interface FreeTrialInfoBannerProps {
  restrictionReason: FreeTrialRestrictionReason;
}

export default function FreeTrialInfoBanner({ restrictionReason }: FreeTrialInfoBannerProps) {
  const { t } = useTranslation();

  if (!restrictionReason) {
    return null;
  }

  const message =
    restrictionReason === 'in_cart'
      ? t('free_trial_added_to_cart_only_one_trial_allowed')
      : t('only_one_trial_allowed_per_account');

  return (
    <div className={styles.container}>
      <InfoIcon className={styles.icon} />
      <span className={styles.message}>{message}</span>
    </div>
  );
}
